// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2SeVq","right":"styles_right__s7ziG"};